import {
  createScaffolderFieldExtension,
  FieldExtensionComponentProps,
} from '@backstage/plugin-scaffolder-react';
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { MsUserInfo, MsUserPicker } from './MsUserPicker';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';

const MsUserPickerField = (props: FieldExtensionComponentProps<MsUserInfo>) => {
  const { onChange, uiSchema, formData, schema } = props;

  const label = uiSchema?.['ui:title'] || schema?.title || 'MS User';
  const placeholder = uiSchema?.['ui:placeholder'];

  useEffect(() => {
    if (formData && isEmpty(formData)) {
      onChange(undefined);
    }
    // eslint-disable-next-line
  }, []);

  const onUserSelect = (newUser: MsUserInfo | null) => {
    onChange(newUser ?? undefined);
  };

  return (
    <MsUserPicker
      onValueChange={onUserSelect}
      value={formData}
      label={label}
      placeholder={placeholder}
    />
  );
};

export const MsUserPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'MsUserPicker',
    component: MsUserPickerField,
  }),
);
